import { action, observable, makeObservable } from 'mobx';
import { BaseViewStore } from 'core/stores';
import { FulfillmentOrderStore } from 'modules/order/stores';
import { CarrierStore } from 'modules/carrier/stores';
import { TrackingForm } from 'modules/order/forms';
import _ from 'lodash';

class TrackingViewStore extends BaseViewStore {
	@observable trackingStatus;
	@observable selectedCarrier = null;
	@observable isSubmitted = false;
	form = new TrackingForm();

	constructor(rootStore) {
		super(rootStore);
		makeObservable(this);
		this.fulfillmentOrderStore = new FulfillmentOrderStore(this.rootStore);
		this.carrierStore = new CarrierStore(this.rootStore);
		this.form.state.options.set({
			validateOnBlur: false,
			showErrorsOnReset: false,
			validateOnChange: true,
		});
		this.initialize();
	}

	@action.bound async initialize() {
		this.suspend();
		await this.carrierStore.find({ page: 1, rpp: 30 });
		this.carrierOptions = _.map(this.carrierStore.response.item, carrier => {
			return { label: carrier.name, value: carrier.id };
		});
		this.form.$('trackingNumber').onChange = e => {
			this.form.$('trackingNumber').set('value', e.currentTarget.value);
			this.form.$('trackingNumber').validate();
			this.isSubmitted = false;
		};
		this.resume();
	}

	@action.bound onCarrierSelect(carrier) {
		if (carrier && carrier.value) {
			this.selectedCarrier = carrier;
			this.form.$('carrier').invalidate();
			this.isSubmitted = false;
		}
	}

	@action.bound
	onKeyPress = e => {
		if (e.key === 'Enter') {
			if (this.form.$('trackingNumber').value.trim() !== '' && this.selectedCarrier !== null) {
				this.track();
			} else {
				this.form.showErrors(true);
			}
		}
	};

	@action.bound
	track = async () => {
		this.suspend();
		try {
			await this.fulfillmentOrderStore.track({
				carrierId: this.selectedCarrier.value,
				trackingNumber: this.form.$('trackingNumber').value.trim(),
			});
			if (this.fulfillmentOrderStore.response != null && this.fulfillmentOrderStore.response.length > 0) {
				this.trackingStatus = this.fulfillmentOrderStore.response[0].trackingStatus;
			} else {
				this.trackingStatus = null;
			}
			this.isSubmitted = true;
		} catch (err) {
			this.rootStore.notificationStore.error(err);
		}
		this.resume();
	};
}

export default TrackingViewStore;



// WEBPACK FOOTER //
// ./src/modules/order/stores/TrackingViewStore.js